export default __webpack_public_path__ + "static/media/logow.73656fb6.png";